import { Banner, OpacitySlide, PopUp, ReservationCircleButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useGetDMaxCommon, type PopUpResponse } from "@/shared/server";
import { createDate } from "@/utils";
import { Box, Center } from "@chakra-ui/react";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import { type TopSectionProps } from "./topSection.type";

export const TopSection = ({ imgList, sector, color = "#FBF6F2", customSector }: TopSectionProps) => {
    const { data: popUpData } = useGetDMaxCommon<PopUpResponse>({ section: "popup" });
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();
    return (
        <Box position="relative" h={isMobile ? "50dvh" : "100dvh"}>
            {popUpData && (
                <Center
                    position="absolute"
                    top={isMobile ? "108px" : "144px"}
                    left={isTablet ? "24px" : "auto"}
                    right={isTablet ? "auto" : "80px"}
                    zIndex="9999"
                    gap={isMobile ? "36px" : "24px"}
                    flexDir={isTablet ? "column" : "row"}
                >
                    {popUpData.currentPopups.map((currentPopUp) => {
                        const {
                            fromTo: { endDate },
                        } = currentPopUp;
                        const { currentObj } = createDate();
                        const isExpired = currentObj.valueOf() < dayjs(endDate).valueOf();

                        return isExpired && <PopUp key={currentPopUp.postIdx} currentPopUp={currentPopUp} />;
                    })}
                </Center>
            )}
            <OpacitySlide imgList={imgList}>
                {!customSector && (
                    <>
                        <Banner imgList={imgList} sector={sector} />
                        {!isMobile && (
                            <Center
                                w="120px"
                                h="120px"
                                position={isMobile ? "relative" : "absolute"}
                                right={isMobile ? "none" : "100px"}
                                bottom="0px"
                            >
                                <ReservationCircleButton />
                            </Center>
                        )}
                    </>
                )}
            </OpacitySlide>
            <Box position="absolute" bottom="0" w="100%" overflow="hidden">
                <MotionSvg
                    viewBox="50 0 920 100"
                    width="200%" // 1.5파장을 움직이게 하려면 세 배짜리로 설정
                    height={isMobile ? "40px" : "80px"}
                    initial={{ x: 0 }}
                    animate={{ x: ["0%", "-50%", "0%"] }} // 전체의 1/3만 이동 (1.5파장의 반복)
                    transition={{
                        duration: 24,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    preserveAspectRatio="none"
                    style={{ display: "block" }}
                >
                    <path
                        fill={color}
                        d="
                        M0,50
        Q120,0 240,50
        T480,50
        T720,50
        T960,50
        T1200,50
        T1440,50
        T1680,50
        T1920,50
        T2160,50
        T2400,50
        T2640,50
        T2880,50
        T3120,50
        T3360,50
        T3600,50
        T3840,50
        L3840,100
        L0,100
        Z
                        "
                    />
                </MotionSvg>
            </Box>
        </Box>
    );
};

const MotionSvg = motion.svg;
